export default function () {
  this.loadEvents()
}
